

















































import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import BookmarkAddMenu from './bookmark-add-menu.vue'
import BookmarkListMixin from '@/components/bookmark/mixins/bookmark-list-mixin';
import ListPickerDialog, { ListPickerItem } from '@/components/dialogs/list-picker-dialog.vue';

@Component({
  components: {
    BookmarkAddMenu,
    ListPickerDialog
  }
})
export default class BookmarkListDialog extends mixins(BookmarkListMixin) {
  get items(): any[] {
    return this.bookmarks.map<any>((item) => ({
      id: item.id,
      name: item.title,
      index: item.index
    }));
  }

  handleClick(event: ListPickerItem) {
    const bookmark = this.bookmarks.find((item) => item.id === event.id);
    this.handleOpenBookmark(bookmark, true);
  }

  open() {
    const bookmarkSelectDialog = this.$refs.bookmarkSelectDialog as ListPickerDialog;
    bookmarkSelectDialog.open();
  }

  close() {
    const bookmarkSelectDialog = this.$refs.bookmarkSelectDialog as ListPickerDialog;
    bookmarkSelectDialog.close();
  }
}
